import {
  CheckboxOption,
  CheckboxOptions,
} from 'shared/common/ConvertToCheckboxOptions'

import { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'

import {
  deliveryTypeOptions,
  orderTypeOptions,
} from 'modules/Orders/components/OrderListFilter/optionsData'
import { usePayments } from 'modules/Orders/hooks/usePayments'
import { orderStatusOptions } from 'modules/Orders/model/statuses'
import {
  useGetCompaniesQuery,
  useLazyGetBranchesQuery,
} from 'modules/Orders/services/ordersApi'

import { SelectQuery } from 'shared/ui/FormQuery/SelectQuery'

const selectClass = 'w-full min-h-[36px]'

const OrderListFilter = () => {
  const { restaurant } = useParams()
  const { data: companiesData } = useGetCompaniesQuery({
    params: { is_crm: 'true' },
  })
  const [getBranches, { data: branchesData }] = useLazyGetBranchesQuery()
  const { paymentOptions } = usePayments({ isCreateOrder: false })
  const [restaurantName, setRestaurantName] = useState<string>('')

  const [branchOptions, setBranchOptions] = useState<CheckboxOption[]>([])

  useEffect(() => {
    if (companiesData && restaurant) {
      const currentRestaurant = companiesData.result.find(
        (item) => item.slug === restaurant,
      )

      if (currentRestaurant) {
        setRestaurantName(currentRestaurant.name)
        getBranches({
          params: {
            company: `${currentRestaurant.id}`,
            company__slug: currentRestaurant.slug,
          },
        })
      }
    }
  }, [companiesData, restaurant])

  useEffect(() => {
    if (branchesData) {
      setBranchOptions(
        branchesData.result.map((branch) => ({
          label: branch.title,
          value: branch.slug,
        })),
      )
    }
  }, [branchesData])

  return (
    <div className="flex gap-[12px] max-w-[1240px] px-[24px] mt-[4px]">
      <SelectQuery
        placeholder="Филиал"
        className={selectClass}
        options={CheckboxOptions({
          options: branchOptions,
          paramKey: 'branch',
        })}
        queryKey="branch"
      />
      <SelectQuery
        placeholder="Тип заказа"
        className={selectClass}
        options={CheckboxOptions({
          options: orderTypeOptions,
          paramKey: 'delivery_way',
        })}
        queryKey="delivery_way"
      />
      <SelectQuery
        placeholder="Тип доставки"
        className={selectClass}
        options={CheckboxOptions({
          options: [
            { label: `Доставка ${restaurantName}`, value: 'NAVAT' },
            ...deliveryTypeOptions,
          ],
          paramKey: 'delivery_type',
        })}
        queryKey="delivery_type"
      />
      <SelectQuery
        placeholder="Статус заказа"
        className={selectClass}
        options={CheckboxOptions({
          options: orderStatusOptions,
          paramKey: 'status',
        })}
        queryKey="status"
      />
      <SelectQuery
        placeholder="Способы оплаты"
        className={`${selectClass}`}
        options={CheckboxOptions({
          options: paymentOptions,
          paramKey: 'payment_method',
        })}
        queryKey="payment_method"
      />
    </div>
  )
}

export default OrderListFilter
